// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/framework7-icons/css/framework7-icons.css
// module id = 789
// module chunks = 2